// components/Sidebar/Sidebar.jsx
import React, { useState } from 'react';
import './Sidebar.css';
import { CaretRightFill, CaretLeftFill } from "react-bootstrap-icons";

const Sidebar = ({ children, initialOpen = true }) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  return (
    <div className="sidebar-wrapper">
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        {/* Botón de toggle */}
        <button 
          className={`sidebar-toggle ${isOpen ? "sidebar-toggle-open" : "sidebar-toggle-closed"}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? "Contraer barra lateral" : "Expandir barra lateral"}
        >
          {isOpen ? (<CaretLeftFill/>): (<CaretRightFill/>)}
        </button>
        
        {/* Contenido de la barra lateral */}
        <div className="sidebar-content">
          {children}
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;